/*  The severities that mean the clinical logic found a risk.

    Lives on its own so both the mrx store and the care-plan scope can read it without one
    importing the other. */
export const RISK_SEVERITIES = ['risk_present', 'risk_mild', 'risk_moderate', 'risk_severe', 'confirmed_rdt'];
